import type { Field } from 'models';

type FieldOverride = {
  placeholder?: string;
  hint?: string;
  help?: string;
  label?: string;
};

const CN_FIELD_OVERRIDES: Record<string, FieldOverride> = {
  sender_email: {
    placeholder: 'senderInformation.cn.email.placeholder',
    hint: 'senderInformation.cn.email.hint',
  },
  sender_first_name: {
    label: 'senderInformation.cn.firstName.label',
    placeholder: 'senderInformation.cn.firstName.placeholder',
    hint: 'senderInformation.cn.firstName.hint',
  },
  sender_last_name: {
    label: 'senderInformation.cn.lastName.label',
    placeholder: 'senderInformation.cn.lastName.placeholder',
    hint: 'senderInformation.cn.lastName.hint',
  },
  sender_address1: {
    placeholder: 'senderInformation.cn.address1.placeholder',
    hint: 'senderInformation.cn.address1.hint',
  },
  sender_address2: {
    placeholder: 'senderInformation.cn.address2.placeholder',
    hint: 'senderInformation.cn.address2.hint',
  },
  sender_zip: {
    placeholder: 'senderInformation.cn.postalCode.placeholder',
  },
  sender_phone: {
    placeholder: 'senderInformation.cn.phone.placeholder',
    help: 'senderInformation.cn.phone.hint',
  },
};

export const transformChinaFields = (fields: Field[]): Field[] => {
  return fields.map(field => {
    const override = CN_FIELD_OVERRIDES[field.id];
    if (!override) {
      return field;
    }
    return {
      ...field,
      ...(override.label !== undefined && { label: override.label }),
      ...(override.placeholder !== undefined && {
        placeholder: override.placeholder,
      }),
      ...(override.hint !== undefined && { hint: override.hint }),
      ...(override.help !== undefined && { help: override.help }),
    };
  });
};
